<template>
<div>
  <div class="logo">
    <img src="../common/imgs/phynz.png" alt="phynzLogo">
  </div>
  <div class="container">
    <h1>证书查询</h1>
    <div class="cert-query-group">
      <input type="text" class="cert-query-input" placeholder="请输入证书编号" v-model="certNo">
      <button class="cert-query-button" @click="queryCert"></button>
    </div>
    <div class="loading" v-show="searchLoading">
      <vue-loading-circle></vue-loading-circle>
    </div>
    <div class="cert" v-show="searchSuccess">
      <div class="cert-item">
        <div class="cert-img">
          <img class="cert-pdf" ref="pdf" :src="certData.img"/>
        </div>
        <button @click="download">下载证书</button>
        <div class="cert-text">
          <div class="text-item" v-for="text in certData.info" :key="text.title">
            <h4>{{text.title}}</h4>
            <p v-for="(content,index) in text.content" :key="index">{{content[index+1]}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="err-msg" v-show="searchFailed">未找到编码对应证书，请核实证书编码。</div>
    <vue-footer class="vue-footer"></vue-footer>
  </div>
</div>
</template>
<script>
import VueLoadingCircle from '@/components/LoadingCircle.vue'
import VueFooter from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'CertQuery',
  components: {VueFooter, VueLoadingCircle },
  data() {
    return {
      certNo: '',
      certData: {},
      searchFailed: false,
      searchSuccess: false,
      searchLoading: false
    }
  },
  computed: {
  },
  methods: {
    download() {
      window.open(this.certData.file)
    },
    reset() {
      this.certData = {},
      this.searchFailed = false
      this.searchSuccess = false
    },
    queryCert() {
      this.reset()
      this.searchLoading = true
      axios({
        method: 'post',
        url: '/libra/v2/api/certificate/search',
        timeout: 5000,
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        },
        data: {
          // TODO 如果this.certNo为网址,则它会被拼接在/libra/v2/api/certificate/search后
          cert_code: this.certNo
        }
      }).then((response) => {
        console.log(response)
        const responseData = response.data
        if (responseData.err_code === 0) {
          this.certData = responseData.result
          this.searchLoading = false
          this.searchSuccess = true
        } else {
          this.searchLoading = false
          this.searchFailed = true
        }
      }).catch((err) => {
        this.searchLoading = false
        alert('网络问题，请重试')
      })
    }
  },
  created() {
  }
}
</script>
<style lang="less" scoped>
@import '../common/styles/variable.less';
.logo {
  height: 3rem;
  padding-top: 20px;
  padding-left: 20px;
  img {
    height: 100%;
  }
}
.container {
  max-width: 1000px;
  margin: 0 auto 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 2rem 0;
}
h1 {
  text-align: center;
  color: @phynz-blue;
  margin-top: 5rem;
  font-weight: 400;
  font-size: 1.5rem;
}
.err-msg {
  text-align: center;
  font-size: 1rem;
  margin-bottom: 60px;
}
.cert {
  margin: 60px auto 60px;
  width: 100%;
  .cert-item {
    .cert-text {
      color: #000;
      width: 80%;
      margin-top: 60px;
      .text-item {
        margin: 20px 0 20px;
        p {
          margin: 0;
        }
        h4 {
          margin: 5px 0 5px;
          display: inline-block;
        }
      }
    }
    .cert-img {
      width: 100%;
      position: relative;
      // 伪元素用于为iframe撑开高度，并用padding-bottom控制高度与宽度等比缩放
      &::before {
        content: "";
        width: 100%;
        padding-bottom: 82%;
        display: block;
      }
      .cert-pdf {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
      }
    }
  }
}
.cert-query-group {
  height: 50px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .cert-query-input {
    flex: 1;
    margin-right: 15px;
    font-size: 16px;
  }
  .cert-query-button {
    width: 60px;
    border: none;
    border-radius: 2.6px;
    background-color: #3266cc;
    cursor: pointer;
    position: relative;
    &::before {
      content: '';
      display: block;
      height: 11px;
      width: 11px;
      border: 3px solid #fff;
      border-radius: 100px;
      position: absolute;
      top: 15px;
      left: 20px;
    }
    &::after {
      content: '';
      display: block;
      height: 3px;
      width: 10px;
      background-color: #fff;
      border-radius: 100px;
      transform: rotateZ(45deg);
      position: absolute;
      top: 30px;
      left: 32px;
    }
  }
}
.vue-footer {
  margin-top: 60px;
}
.loading {
  margin-top: 60px;
}
.err-msg {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/CertQuery.vue